import { useLayoutEffect,useEffect,useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Dashboard from "../components/Dashboard";
import { useNavigate } from "react-router-dom";



export default function Home() {
  
    const navigate = useNavigate();

    useLayoutEffect(()=>{
        const userString = sessionStorage.getItem("user");
       if(!userString){
        navigate('/login')
       }
    },[])
 
    return (
       
         <div className="homeWrapper">
            <div className="rightContainer" id="rightContainer">
                <Header />
                <p className="heading">CG NET <span>Knowledge Base System</span></p>
                <Dashboard />
                <Footer />
            </div>
        </div>
      
    )
}